module.exports = __webpack_public_path__ + "static/media/RRD4-BG1.00d7737f.jpg";